var o=require("./client.js"),e=require("./client.css");const t=process.env.APPLICATION;window.AppFlow[t].init({rootElement:document.getElementById("root"),config:{},additionalStyles:[],hydrate:!0});
